import {ApiErrorResponseData} from './api-error-response-data';

export class ApiErrorResponse {
    public data: ApiErrorResponseData;
    public status: number;

    constructor(apiErrorResponse?: ApiErrorResponse) {
        this.data = apiErrorResponse && apiErrorResponse.data || new ApiErrorResponseData();
        this.status = apiErrorResponse && apiErrorResponse.status || null;
    }
}
